import { render, staticRenderFns } from "./LeadsAiTab.vue?vue&type=template&id=6ca66884&scoped=true&"
import script from "./LeadsAiTab.vue?vue&type=script&lang=js&"
export * from "./LeadsAiTab.vue?vue&type=script&lang=js&"
import style0 from "./LeadsAiTab.vue?vue&type=style&index=0&id=6ca66884&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca66884",
  null
  
)

export default component.exports